const degrees = 'degrees'
const decibels = 'decibels'

export const customInputTypes = {
  degrees,
  decibels,
}